 class LazyLoader {
    constructor(selector) {
        this.lazyImages = document.querySelectorAll(selector);
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.observeImages();
    }

    observeImages() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    const src = img.getAttribute('data-src');

                    if (src) {
                        img.setAttribute('src', src);
                        img.removeAttribute('data-src');
                        observer.unobserve(img);
                    }
                }
            });
        };

        this.observer = new IntersectionObserver(handleIntersection, this.options);

        this.lazyImages.forEach(img => {
            this.observer.observe(img);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    // Create an instance of the LazyLoader class
    const lazyLoader = new LazyLoader('.lazy-loaded');
});


//for background images
class LazyBackgroundLoader {
    constructor(selector) {
        this.lazyElements = document.querySelectorAll(selector);
        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };
        this.observeElements();
    }

    observeElements() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const src = element.getAttribute('data-src');

                    if (src) {
                        element.style.backgroundImage = 'url(' + src + ')';
                        element.removeAttribute('data-src');
                        observer.unobserve(element);
                    }
                }
            });
        };

        this.observer = new IntersectionObserver(handleIntersection, this.options);

        this.lazyElements.forEach(element => {
            this.observer.observe(element);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const lazyBackgroundLoader = new LazyBackgroundLoader('.lazy-bg');
});
